import styled from '@emotion/styled'

import { useCallback, useEffect, useState } from 'react'

import ButtonText from '@segment/matcha/components/ButtonText'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import { useTableOfContents } from '@segment/matcha/recipes/TableOfContents'

import * as Section from '@segment/matcha/recipes/Section'

import TableOfContentsBase, * as TableOfContents from '@segment/matcha/recipes/TableOfContents'

import { scrollToAnchor } from '@segment/utils/useScrollToAnchor'

const tableOfContents = [
  {
    id: `introduction`,
    label: `Introduction`,
  },
  {
    id: `keyFindings`,
    label: `Key Findings`,
  },
  {
    id: `ourTake`,
    label: `Our Take`,
  },
  {
    id: `methodology`,
    label: `Methodology`,
  },
]

const BUTON_TEXT = `Download the full report`

const SectionNav = () => {
  const [activeTableItem, setActiveTableItem] = useState(`introduction`)
  const [precedenceOnClick, setPrecedenceOnClick] = useState(``)
  const { activeElementId } = useTableOfContents({ ids: tableOfContents.map((el) => el.id) })

  const handleSideBarItemClick = (id: string) => {
    setPrecedenceOnClick(id)
    setActiveTableItem(id)
    scrollToAnchor(id, -100)
  }

  const handleScrollEnd = useCallback(() => {
    if (activeElementId && !precedenceOnClick) {
      setActiveTableItem(activeElementId)
    }

    setPrecedenceOnClick(``)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeElementId])

  useEffect(() => {
    window.addEventListener(`scrollend`, handleScrollEnd)

    return () => {
      window.removeEventListener(`scrollend`, handleScrollEnd)
    }
  }, [handleScrollEnd])

  return (
    <StickyContainer>
      <Section.Sticky>
        <TableOfContentsBase>
          <TableOfContents.Title>Jump to section</TableOfContents.Title>
          <TableOfContents.List>
            {tableOfContents.map((item) => (
              <TableOfContents.ListItem
                key={item.id}
                active={item.id === activeTableItem}
                onClick={() => handleSideBarItemClick(item.id)}
              >
                <TableOfContents.LeftContent>
                  <TableOfContents.Text variant="pSmall">{item.label}</TableOfContents.Text>
                </TableOfContents.LeftContent>
              </TableOfContents.ListItem>
            ))}
          </TableOfContents.List>
        </TableOfContentsBase>
        <ButtonWrapper>
          <ButtonText iconEnd={ChevronRightIcon} onClick={() => scrollToAnchor(`heroForm`, -100)}>
            {BUTON_TEXT}
          </ButtonText>
        </ButtonWrapper>
      </Section.Sticky>
    </StickyContainer>
  )
}

const ButtonWrapper = styled.div`
  padding-top: 40px;
`

const StickyContainer = styled.div`
  position: relative;
  height: 100%;
}`

export default SectionNav
